import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
} from '@angular/router';
import {
  DroitClientFinal,
  getStringDroitClientFinal,
} from '@logaia_users/logaia-dto';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

export const dossierAccessGuard: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const dossierService = inject(DossierService);
  const dossierId = dossierService.dossierId;

  const collaborateurService = inject(PreferenceService);
  const asUser = childRoute.queryParamMap.get('asUser');
  if (asUser) {
    const interlocuteur = dossierService
      .getDossierAccessRights()
      .find((i) => i.interlocuteurId === +asUser);
    if (interlocuteur) {
      collaborateurService.forceClientMode = true;
      collaborateurService.asUser = interlocuteur.interlocuteurId;
    }
  }

  if (collaborateurService.isClient || asUser) {
    const dossierAccess = dossierService.getCurrentDossierAccessRights();
    if (dossierAccess?.accesComplet) {
      return true;
    }

    const droits = dossierAccess?.droits;
    if (droits) {
      const requiredPermission = childRoute.data['droit'] as
        DroitClientFinal | undefined;
      if (
        requiredPermission &&
        !droits.includes(getStringDroitClientFinal(requiredPermission))
      ) {
        router.navigate([`dossier/${dossierId}/accueil`]);
        return false;
      }
      return true;
    } else {
      return true;
    }
  } else {
    // Si le collaborateur n'est pas un client, on autorise toujours l'accès.
    return true;
  }
};
